<!-- eslint-disable -->
<template>
<div class="G_modal" v-show="!DV_loading">
    <modal-header
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="selfClose"
      :title="modalTitle">
    </modal-header>
    <hr>
    <div class="p2s3m5_list" v-if="Object.keys(accountNotifications).length > 0">
      <div
        v-for="entry in accountNotifications"
        :key="entry['notice_id']"
        class="p2s3m5_entry"
        >

        <div  v-if="entry['notice_type'] === 'org_invite'"
          class="p2s3m5_description"
          >
          {{entry['description']}} from {{entry['source_user']}}
        </div>
        <div v-else
          class="p2s3m5_description"
          >
           {{entry['description']}}
        </div>
        
        
        <div class="p2s3m5_response_buttons">
          <button class=""
            v-for="(option,index2) in entry['options']"
            :key="entry['notice_id'] + index2"
            @click="sendNotificationResponse(entry['notice_id'],option)"
            >{{option.charAt(0).toUpperCase() + option.substr(1)}}</button>
        </div>
      </div>
    </div>
    <div v-else>
      <h3>There Are Currently No Notifications For This User Account</h3>
    </div>

</div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../p2ModalHeader";
import c22FullPathLabel from "../../Labels/c22FullPathLabel";
import { bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import sendAccountNotificationResponse from '../../../watchdog_includes/legacy_calls/p2s1t12_SendAccountNotificationRepsonse'
export default {
  name: "p2s3m5AccountNotifications",
  components: {
    ModalHeader,
    c22FullPathLabel,
  },
  data: function() {
    return {
      modalTitle:'Account Notifications',
      defaultModal:'default',
      accountNotifications:{},
      accountNotificationsList:[],
      DV_loading: true
    };
  },
  mixins: [bi10ModalTemplate],
  methods: {
    waitWatchdogReadyCallback() {
      this.accountNotifications = window.G_watchdog_data.IV_account_notificaitons;
      this.DV_loading = false;
    },
    sendNotificationResponse(notice_id,response) {
      sendAccountNotificationResponse(window.G_watchdog_data.IV_user_info['contact_email'],notice_id ,response);
    }
  },
  watch: {
    accountNotifications: {
      handler: function() {
        for(var key in this.accountNotifications) {
        
        }
    },
    
    deep:true}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s3accountSettings/p2s3m5Notifications.vue